import React from 'react';

import { StyledFlexItem } from './styled';
import type { FlexItemProps } from './types';

export const FlexItem: React.FC<FlexItemProps> = ({
  children,
  flex,
  grow,
  shrink,
  basis,
  order,
  maxWidth,
  alignSelf,
  className,
  testId,
  ...props
}) => {
  return (
    <StyledFlexItem
      {...(flex !== undefined && { $flex: flex })}
      {...(grow !== undefined && { $grow: grow })}
      {...(shrink !== undefined && { $shrink: shrink })}
      {...(basis !== undefined && { $basis: basis })}
      {...(order !== undefined && { $order: order })}
      {...(maxWidth !== undefined && { $maxWidth: maxWidth })}
      {...(alignSelf !== undefined && { $alignSelf: alignSelf })}
      className={className}
      data-testid={testId}
      {...props}
    >
      {children}
    </StyledFlexItem>
  );
};